import { P2GAlert, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { lazy, Suspense, useMemo } from 'react';
import { QuoteError } from '~/lib/types/basket-types';

const CmsContent = lazy(() => import('~/components/core/content/cms-content'));

type props = {
  onClose: () => void;
  errorMessages?: QuoteError[];
};

const InvalidQuote: React.FC<props> = ({ errorMessages }) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);

  const message = useMemo(() => {
    if (
      errorMessages?.some((x) => x.type.indexOf('service-unavailable') >= 0) ||
      errorMessages?.some((x) => x.type.indexOf('routing-unavailable') >= 0)
    ) {
      return t('SERVICE_SWITCHER_UNAVAILABLE_QUOTE_MESSAGE', {
        defaultValue: `Your selected courier does not ship between these locations. Please choose an alternative service.`
      });
    }

    // Over the max allowed value
    if (errorMessages?.some((x) => x.type.indexOf('service-ineligible') >= 0 && x.title === 'Value Out Of Bounds')) {
      return t('SERVICE_SWITCHER_VALUE_OUT_OF_BOUNDS_QUOTE_MESSAGE', {
        defaultValue: `This service cannot accept parcels of this value. Please choose an alternative service.`
      });
    }

    return t('SERVICE_SWITCHER_INVALID_QUOTE_MESSAGE', {
      defaultValue: `Your parcel is too large or too heavy for the service you have selected. Please choose an alternative service.`
    });
  }, [errorMessages, t]);

  return (
    <Suspense>
      <CmsContent contentKey="service-switcher-invalid-service" wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}>
        <P2GGrid container direction="column" spacing={2}>
          <P2GGrid item>
            <P2GText variant="h2" dataTestId="quotes-container-title">
              {t('SERVICE_SWITCHER_INVALID_QUOTE_TITLE', { defaultValue: 'Alternative Services' })}
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GAlert type="error">
              <P2GText>{message}</P2GText>
            </P2GAlert>
          </P2GGrid>
        </P2GGrid>
      </CmsContent>
    </Suspense>
  );
};
export default InvalidQuote;
